import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import type { Tag } from '#tags/types/tag.type';

import { Uri } from '#constants/uri';

/**
 * Retrieves the tags associated with a specific mailing.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param mailingId - The unique identifier of the mailing for which to fetch tags.
 * @returns A promise that resolves to an `OperationResultWithData` containing an array of `Tag` objects.
 * @throws Will throw an error if the HTTP request fails.
 */
export const getMailingTags = async (instance: KyInstance, mailingId: number) => {
  try {
    return await instance
      .get<OperationResultWithData<Tag[]>>(formatString(Uri.mailing.getTags, mailingId.toString()))
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
